
import React, { useState } from 'react';
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import { getDatabase, ref as dbRef, update } from 'firebase/database';
import './ImageUpload.css';

const ImageUpload = ({ studentId }) => {
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState('');
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState('');

  const handleImageChange = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      setImage(file);
      setPreview(URL.createObjectURL(file));
      setMessage(''); // Clear previous messages
    }
  };

  const handleUpload = () => {
    if (!image) {
      setMessage('Please select an image first.');
      return;
    }
    if (!studentId) {
        setMessage('Error: Student ID is missing.');
        return;
    }

    setUploading(true);
    setMessage(`Uploading ${image.name}...`);

    const storage = getStorage();
    // Create a unique file path for the image
    const imagePath = `student_photos/${studentId}/${image.name}`;
    const imageStorageRef = storageRef(storage, imagePath);

    uploadBytes(imageStorageRef, image)
      .then((snapshot) => {
        return getDownloadURL(snapshot.ref);
      })
      .then((downloadURL) => {
        // Now, save the download URL to the Realtime Database
        const db = getDatabase();
        const studentDbRef = dbRef(db, `users/${studentId}`);
        return update(studentDbRef, {
          photoURL: downloadURL,
        });
      })
      .then(() => {
        setUploading(false);
        setMessage('Upload successful! The student photo has been updated.');
        setPreview('');
        setImage(null);
      })
      .catch((error) => {
        setUploading(false);
        setMessage(`Upload failed: ${error.message}`);
        console.error("Upload error:", error);
      });
  };

  return (
    <div className="image-upload-container">
      <h4>Upload Student Photo</h4>
      {preview && <img src={preview} alt="Preview" className="image-preview" />}
      <input type="file" onChange={handleImageChange} accept="image/*" className="form-control" />
      <button onClick={handleUpload} disabled={uploading} className="btn btn-success mt-2">
        {uploading ? 'Uploading...' : 'Upload Image'}
      </button>
      {message && <p className="upload-message mt-2">{message}</p>}
    </div>
  );
};

export default ImageUpload;
